import type {
  AuthenticatePinCodeRequest,
  AuthenticatePinCodeResponse,
  SendPinCodeRequest,
  SendPinCodeResponse,
} from '@dtos/pin-code';
import { ErrorTypes } from '@models/Errors';
import { SendPinCodeResult } from '@models/send-pin-code-result';
import { IConfigurationValuesService } from '@services/ConfigurationValuesService';
import { IHttpService } from '@services/HttpService';
import { AxiosError } from 'axios';
import { RequireGuestToken } from './http/authorisation-interceptor';

export interface IPinCodeService {
  sendRepresentativePinCodeToWorker(
    request: SendPinCodeRequest
  ): Promise<SendPinCodeResult>;
  authenticateWithPinCode(
    request: AuthenticatePinCodeRequest
  ): Promise<AuthenticatePinCodeResponse | null>;
}

export default class PinCodeService implements IPinCodeService {
    private readonly urlPrefix: string;

    constructor(
        private httpService: IHttpService,
        private configurationValuesService: IConfigurationValuesService
    ) {
        this.urlPrefix = `${this.configurationValuesService.apiUrl}/worker-onboarding/external/representative`;
    }

    @RequireGuestToken
    async sendRepresentativePinCodeToWorker(request: SendPinCodeRequest): Promise<SendPinCodeResult> {
        try {
            const url = `${this.urlPrefix}/sendPinCode`;
            await this.httpService.post<SendPinCodeResponse, SendPinCodeRequest>(url, request);
            return SendPinCodeResult.Success;
        } catch (error: unknown) {
            const isAxiosError = <T>(error: unknown): error is AxiosError<T> => {
                return (error as AxiosError).isAxiosError;
            };
            if (isAxiosError<{ errorCode: string }>(error)) {
                // @ts-ignore
                if (error.response?.status === 400) {
                    // @ts-ignore
                    switch (error.response?.data?.errorCode) {
                        case ErrorTypes.ApplicationApproved:
                            return SendPinCodeResult.ApplicationApproved;
                        case ErrorTypes.ApplicationDeclined:
                            return SendPinCodeResult.ApplicationDeclined;
                        case ErrorTypes.NotFound:
                            return SendPinCodeResult.InvalidId;
                        default:
                            return SendPinCodeResult.UnrecognisedError;
                    }
                }
            }

            return SendPinCodeResult.UnrecognisedError;
        }
    }

    @RequireGuestToken
    async authenticateWithPinCode(request: AuthenticatePinCodeRequest): Promise<AuthenticatePinCodeResponse | null> {
        try {
            const url = `${this.urlPrefix}/authenticate`;
            const response = await this.httpService.post<
                AuthenticatePinCodeResponse,
                AuthenticatePinCodeRequest
            >(url, request);
            return response.data;
        } catch (error) {
            return null;
        }
    }

}



// WEBPACK FOOTER //
// ./src/services/pin-code-service.ts